export enum SamplesLanguages {
    EN = 'en',
    FR = 'fr',
    ES = 'es',
}

export enum LanguageToLocale {
    'en' = 'en_US',
    'fr' = 'fr_FR',
    'es' = 'es_ES',
}

export enum UnsupportedSamplesLanguages {
    DE = 'de',
    IT = 'it',
    JA = 'ja',
    PT = 'pt',
}
